import { render, staticRenderFns } from "./OtherMsg.vue?vue&type=template&id=627f1f3a&scoped=true&"
import script from "./OtherMsg.vue?vue&type=script&lang=js&"
export * from "./OtherMsg.vue?vue&type=script&lang=js&"
import style0 from "./OtherMsg.vue?vue&type=style&index=0&id=627f1f3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f1f3a",
  null
  
)

export default component.exports